import { TableCell, TableHead, TableRow } from "@material-ui/core";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import arrayMove from "array-move";
import jsonExport from "jsonexport/dist";
import { useEffect, useState } from "react";
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  downloadCSV,
  Edit,
  EditButton,
  Filter,
  List,
  RecordContextProvider,
  required,
  SelectInput, //
  Show,
  ShowButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Field } from "react-final-form";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { CustomDeleteHotSearchButton } from "./components/custom-delete-hot-search-button";

const SearchFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput
        onChange={() => {
          // setTimeout(function () {
          //   window.location.reload(true);
          // }, 2500);
        }}
        label="Keyword"
        source="search"
        alwaysOn
      />
      <SelectInput
        onChange={() => {
          // setTimeout(function () {
          //   window.location.reload(true);
          // }, 1000);
        }}
        label="Status"
        source="enabled"
        choices={[
          { id: "true", name: "Enabled" },
          { id: "false", name: "Disabled" },
        ]}
        alwaysOn
      />
    </Filter>
  );
};

const DragHandle = SortableHandle(() => (
  <ListItemIcon>
    <DragHandleIcon />
  </ListItemIcon>
));

const DataGridEmptyView = () => {
  return (
    <div style={{ margin: "16px" }}>
      <p className="MuiTypography-root MuiTypography-body2">No results found</p>
    </div>
  );
};

const DatagridHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell style={{}}>Name</TableCell>
      <TableCell style={{}}>Order</TableCell>
      <TableCell style={{}}>Status</TableCell>
      <TableCell style={{}}></TableCell> {/* Show */}
      <TableCell style={{}}></TableCell> {/* Edit */}
      <TableCell style={{}}></TableCell> {/* Remove */}
      <TableCell style={{}}></TableCell> {/* Drag */}
    </TableRow>
  </TableHead>
);

const MyDatagridBody = ({ items, setItems, data, ids }) => {
  useEffect(() => {
    const list = [];
    for (const id of ids) {
      list.push(data[id]);
    }
    setItems(list);
  }, [data]);

  return items.map((item, index) => {
    return <SortableItem2 item={item} index={index} pos={index} />;
  });
};

const SortableItem2 = SortableElement(({ item, pos, ...props }) => {
  return <MyDatagridRow item={item} pos={pos} {...props} />;
});

const MyDatagridRow = ({ item }) => {
  return (
    <RecordContextProvider value={item}>
      <TableRow>
        <TableCell>{item.search}</TableCell>
        <TableCell>{item.order}</TableCell>

        <TableCell>
          {item.enabled ? (
            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="true">
              <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
            </svg>
          ) : (
            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="false">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
            </svg>
          )}
        </TableCell>

        <TableCell>
          <ShowButton record={item} />
        </TableCell>

        <TableCell>
          <EditButton record={item} />
        </TableCell>

        <TableCell>
          <CustomDeleteHotSearchButton record={item} />
        </TableCell>
        <TableCell>
          <DragHandle />
        </TableCell>
      </TableRow>
    </RecordContextProvider>
  );
};

const SortableListContainer = SortableContainer(({ profileClass, ...props }) => {
  const { setItems, items } = props;

  const exporter = (programmes) => {
    const BOM = "\uFEFF";

    jsonExport(programmes, {}, (err, csv) => {
      downloadCSV(`${BOM} ${csv}`, "hot-searches"); // download as 'posts.csv` file
    });
  };

  return (
    <List {...props} filter={{ profile_class: profileClass }} sort={{ field: "order", order: "ASC" }} pagination={false} filters={<SearchFilter />} exporter={exporter}>
      <Datagrid //
        header={<DatagridHeader />}
        body={<MyDatagridBody profileClass={profileClass} items={items} setItems={setItems} />}
        empty={<DataGridEmptyView />}
      />
    </List>
  );
});

const SortableList = ({ profileClass, ...props }) => {
  const [items, setItems] = useState([]);

  const dataProvider = useDataProvider();

  const onSortEnd = ({ oldIndex, newIndex }) => {
    var oldItem = items[oldIndex];
    var newItem = items[newIndex];
    setItems((items) => arrayMove(items, oldIndex, newIndex));

    var data = {
      hotSearchId: oldItem.id,
      newOrder: newItem.order,
    };
    dataProvider.update("hot-searchs-order", data).then(() => {
      // setArtists(data);
      window.location.reload(true);
    });
  };

  return (
    <SortableListContainer //
      {...props}
      profileClass={profileClass}
      items={items}
      setItems={setItems}
      onSortEnd={onSortEnd}
      useDragHandle={true}
      lockAxis="y"
    />
  );
};

const HotSearchList = ({ profileClass, ...props }) => {
  return <SortableList profileClass={profileClass} {...props} />;
};

const HotSearchTitle = ({ record }) => {
  return <span>HotSearch {record ? `${record.search}` : ""}</span>;
};

const HotSearchShow = (props) => (
  <Show {...props} title={<HotSearchTitle />}>
    <SimpleShowLayout>
      <TextField source="search" />
      <TextField label="Order Number" source="order" />
      <BooleanField source="enabled" />
    </SimpleShowLayout>
  </Show>
);

const HotSearchEdit = ({ profileClass, ...props }) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic" title={<HotSearchTitle />}>
      <SimpleForm>
        <Field name="pc" component="input" type="hidden" defaultValue={profileClass} />
        <TextInput source="search" validate={required()} />
        <BooleanInput source="enabled" validate={required()} />
      </SimpleForm>
    </Edit>
  );
};

const HotSearchCreate = ({ profileClass, ...props }) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  const onSuccess = () => {
    if (profileClass == "general") {
      window.location.href = "/admin/#/hot-searchs";
    } else if (profileClass == "kids") {
      window.location.href = "/admin/#/kids-hot-searchs";
    }
    // window.location.reload(true);
  };

  return (
    <Create {...props} onFailure={onFailure} onSuccess={onSuccess} mutationMode="pessimistic">
      <SimpleForm
        redirect={false}
        // redirect={() => (profileClass == "kids" ? "/kids-hot-searchs" : "/hot-searchs")}
      >
        <Field name="pc" component="input" type="hidden" defaultValue={profileClass} />
        <TextInput source="search" validate={required()} />
        {/* <NumberInput source="order" validate={required()} /> */}
        <BooleanInput source="enabled" defaultValue={true} validate={required()} />
      </SimpleForm>
    </Create>
  );
};

export const GeneralHotSearchList = (props) => <HotSearchList profileClass="general" {...props} />;
export const KidsHotSearchList = (props) => <HotSearchList profileClass="kids" {...props} />;

export const GeneralHotSearchShow = (props) => <HotSearchShow profileClass="general" {...props} />;
export const KidsHotSearchShow = (props) => <HotSearchShow profileClass="kids" {...props} />;

export const GeneralHotSearchCreate = (props) => <HotSearchCreate profileClass="general" {...props} />;
export const KidsHotSearchCreate = (props) => <HotSearchCreate profileClass="kids" {...props} />;

export const GeneralHotSearchEdit = (props) => <HotSearchEdit profileClass="general" {...props} />;
export const KidsHotSearchEdit = (props) => <HotSearchEdit profileClass="kids" {...props} />;
